export default import.meta.ROLLDOWN_FILE_URL_kEv_7VA$kqF3ey15VrrTtQ